import top from "../../images/planes/top-planes-home.png";
import funnyOldies from "../../images/planes/header-planes.jpg";
import mobileSw from "../../images/planes/mobile-sw.png";
import prettyLadies from "../../images/planes/old-young-ladies.png";
import drinkingOldies from "../../images/planes/drinking-oldies.png";

import "./PlanGold.css";
import EllieTips from "../molecules/EllieTips";
import Funcionalidades from "../molecules/Funcionalidades";
import FuncionalidadesBig from "../molecules/FuncionalidadesBig";
import Conoce from "../molecules/Conoce";

import Plan from "../atoms/Plan";

import Contacto from "../molecules/Contacto";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getOneSubscriptions } from "../../services/subscription.service";
import { IPlan, SubscriptionType } from "../../types/subscription";
import React from "react";

export const SubscriptionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState<IPlan>();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id) {
      setOneSubscription();
    } else {
      navigate(-1);
    }
  }, [id]);

  function setOneSubscription() {
    if (id)
      getOneSubscriptions(id)
        .then((res) => {
          setSubscription(res);
        })
        .catch((error) => {
          navigate(-1);
        });
  }

  return ( 
    <>
      <img
        src={funnyOldies}
        alt="Funny Oldies"
        style={{ width: "100%", margin: "0 auto" }}
      />

      <div id="plan-gold" style={{ backgroundColor: "#F5F7F9" }}>
        <div className="plan-gold-container">
          <img className="plan-gold-image-top" src={top} alt="Top Plan Gold" />
        </div>
        {subscription && (
          <React.Fragment>
            <div className="plan-gold-container">
              <div className="plan-gold-box-center">
                <h1>
                  Plan Gold{" "}
                  {subscription.subscription_type ===
                    SubscriptionType.GOLDLOAN && ` Comodato`}
                </h1>
                <p>
                  Trabajemos juntos en la prevención y en la medicina
                  personalizada. Plan GOLD{" "}
                  {subscription.subscription_type ===
                    SubscriptionType.GOLDLOAN && ` Comodato`}{" "}
                  de Ellie Care, la manera mas sofisticada de conectarte con tu
                  bienestar.
                </p>
              </div>
            </div>

            <div className="plan-gold-container">
              <div className="plan-gold-box-image" style={{ display: "flex" }}>
                <img
                  className="plan-gold-image"
                  src={mobileSw}
                  alt="Mobile Planes"
                />
              </div>
              <div className="plan-gold-box-left">
                <h1>Dispositivos</h1>
                <p>
                  Baja nuestra <b>aplicación en tu celular</b> y conéctate con
                  nuestro Ellie Center, nuestro centro de monitoreo.
                </p>
                <p>
                  Con tu <b>Ellie Watch de Samsung</b>{" "}
                  {subscription.subscription_type ===
                    SubscriptionType.GOLDLOAN &&
                    ` que obtendrás en
              comodato al momento de realizar la suscripción al plan`}
                  podrás estar conectado con tu Red de Ayuda y nuestro Ellie
                  Center, estes donde estes, 24x7. Estés en tu hogar o en la
                  calle, estamos con vos.
                </p>
              </div>
            </div>
            <div
              className="plan-gold-container"
              style={{ flexDirection: "column" }}
            >
              <div className="plan-gold-box-center">
                <Plan subscription={subscription} full={false} />
              </div>
              {subscription.subscription_type === SubscriptionType.GOLD && (
                <div className="plan-gold-box-center">
                  <p>
                    Vas a poder comprar tu SmartWatch Samsung Ellie Care luego
                    de la suscripción al plan.
                  </p>
                  <p>
                    Pasado el tiempo mínimo de permanencia, el reloj será tuyo.
                    De no cumplirse deberás devolverlo.
                  </p>
                </div>
              )}
            </div>
          </React.Fragment>
        )}

        <Funcionalidades />

        <div className="plan-gold-container" style={{ marginTop: "50px" }}>
          <div
            className="plan-gold-box-right"
            // style={{ alignItems: "flex-end", textAlign: "right" }}
          >
            <h1>Red de Ayuda</h1>
            <p>
              La Red de Ayuda es el grupo de personas que querés que se enteren
              cuando activás el Botón de Ayuda. Además de contar con la
              asistencia de nuestro Ellie Center, puedes definir 5 personas en
              tu Red de Ayuda.
            </p>
            <p>
              Vas a ser asistido por nuestro Ellie Center 24x7, estés donde
              estés. ¡Junto a tu familia y amigos, nosotros también estamos!
            </p>
          </div>
          <div className="plan-gold-box-image">
            <img
              className="plan-gold-image-big"
              src={prettyLadies}
              alt="Mobile Planes"
            />
          </div>
        </div>

        <div className="plan-gold-container">
          <div className="plan-gold-box-image">
            <img
              className="plan-gold-image-big"
              src={drinkingOldies}
              alt="Mobile Planes"
            />
          </div>
          <div
            className="plan-gold-box-left"
            // style={{ alignItems: "flex-start", textAlign: "left" }}
          >
            <h1>Programa Ellie Coins *</h1>
            <p>
              Desde Ellie Care promovemos hábitos saludables para que tengas un
              mayor bienestar y disfrutes mas de tus afectos.
            </p>
            <p>
              Con este plan podes sumar Ellie Coins manera mas rápida y
              premiando hábitos saludables, que podrás canjear por beneficios y
              productos únicos e ideales para vos.
            </p>
            <p>* Próximamente...</p>
          </div>
        </div>
        <EllieTips />
        <FuncionalidadesBig />
        <Conoce />
        <section id="contact">
          <Contacto />
        </section>
      </div>
    </>
  );
};

export default SubscriptionDetail;
